import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/views/Layout/Layout.vue'
import TermLayout from '@/views/Layout/TermLayout.vue'

const Login = () => import('@/views/Login.vue')
const Register = () => import('@/views/Register.vue')

const Cookie = () => import('@/views/Cookie.vue')
const Terms = () => import('@/views/Terms.vue')
const Privacy = () => import('@/views/Privacy.vue')

const Start = () => import('@/views/Start.vue')
const Scan = () => import('@/views/Scan.vue')
const Profile = () => import('@/views/Profile.vue')
const Setting = () => import('@/views/Setting.vue')

const Exhibition = () => import('@/views/Exhibition.vue')
const ExhibitionList = () => import('@/views/ExhibitionList.vue')

const Introduce = () => import('@/views/Introduce.vue')

const Error = () => import('@/views/Error.vue')

Vue.use(VueRouter)

const LoginPage = {
  path: '/',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
  ],
}

const RegisterPage = {
  path: '/register',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Register',
      component: Register,
    },
  ],
}

const StartPage = {
  path: '/start',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Start',
      component: Start,
    },
  ],
}

const ScanPage = {
  path: '/scan',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Scan',
      component: Scan,
    },
  ],
}

const ProfilePage = {
  path: '/profile',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Profile',
      component: Profile,
    },
  ],
}

const SettingPage = {
  path: '/setting',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Setting',
      component: Setting,
    },
  ],
}

const ExhibitionPage = {
  path: '/exhibition',
  component: Layout,
  children: [
    {
      path: '',
      name: 'Exhibition',
      component: Exhibition,
    },
  ],
}

const ExhibitionListPage = {
  path: '/exhibition-list',
  component: Layout,
  children: [
    {
      path: '',
      name: 'ExhibitionList',
      component: ExhibitionList,
    },
  ],
}

const IntroducePage = {
  path: '/introduce',
  component: Layout,
  children: [
    {
      path: '/',
      name: 'Introduce',
      component: Introduce,
    },
  ],
}

const CookiePage = {
  path: '/cookie',
  component: TermLayout,
  children: [
    {
      path: '/',
      name: 'Cookie',
      component: Cookie,
    },
  ],
}

const TermsPage = {
  path: '/terms',
  component: TermLayout,
  children: [
    {
      path: '/',
      name: 'Terms',
      component: Terms,
    },
  ],
}

const PrivacyPage = {
  path: '/privacy',
  component: TermLayout,
  children: [
    {
      path: '/',
      name: 'Privacy',
      component: Privacy,
    },
  ],
}

const ErrorPage = {
  path: '/error',
  component: Error,
  children: [
    {
      path: '/',
      name: 'Error',
      component: Error,
    },
  ],
}

const routes = [
  LoginPage,
  RegisterPage,
  StartPage,
  ScanPage,
  ProfilePage,
  SettingPage,
  ExhibitionPage,
  ExhibitionListPage,
  IntroducePage,
  CookiePage,
  TermsPage,
  PrivacyPage,
  ErrorPage,
  { path: '/*', redirect: '/error' },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
})

export default router
